import { makeAutoObservable } from 'mobx';

import {
  DebtAmount,
  CompactContactInfoSubModule,
  ContactInfoSubModule,
  CreditScore,
  CreditScoreImportance,
  DebtCause,
  DebtGoal,
  DebtTypes,
  EmploymentStatus,
  FutureLoanPlans,
  HouseholdIncome,
  IncomeConsistency,
  NameSubModule,
  PaymentStatus,
  PropertyType,
  State,
  ZipCode,
} from '@subModules';

import { SubModuleRegistry } from '../services/SubModuleRegistry';

export default class SubModuleStore {
  loading = false;

  constructor() {
    makeAutoObservable(this);
    SubModuleRegistry.register('SUB_ZIPCODE', ZipCode);
    SubModuleRegistry.register('SUB_DEBT_AMOUNT', DebtAmount);
    SubModuleRegistry.register('SUB_STATE', State);
    SubModuleRegistry.register('SUB_PROPERTY_TYPE', PropertyType);
    SubModuleRegistry.register('SUB_PAYMENT_STATUS', PaymentStatus);
    SubModuleRegistry.register('SUB_NAME', NameSubModule);
    SubModuleRegistry.register('SUB_HOUSEHOLD_INCOME', HouseholdIncome);
    SubModuleRegistry.register('SUB_FUTURE_LOAN_PLANS', FutureLoanPlans);
    SubModuleRegistry.register('SUB_EMPLOYMENT_STATUS', EmploymentStatus);
    SubModuleRegistry.register('SUB_DEBT_TYPES', DebtTypes);
    SubModuleRegistry.register('SUB_DEBT_CAUSE', DebtCause);
    SubModuleRegistry.register('SUB_DEBT_GOAL', DebtGoal);
    SubModuleRegistry.register(
      'SUB_CREDIT_SCORE_IMPORTANCE',
      CreditScoreImportance
    );
    SubModuleRegistry.register('SUB_CREDIT_SCORE', CreditScore);
    SubModuleRegistry.register('SUB_CONTACT', ContactInfoSubModule);
    SubModuleRegistry.register(
      'SUB_COMPACT_CONTACT',
      CompactContactInfoSubModule
    );
    SubModuleRegistry.register('SUB_INCOME_CONSISTENCY', IncomeConsistency);
  }

  setLoading = (isLoading: boolean) => {
    this.loading = isLoading;
  };
}
